module.exports = __webpack_public_path__ + "media/images/icons/social-facebook-df996a9be5cbbf1db0e9e2df4517f64e.svg";